import { apiClient, ApiResponse } from "./client";

// Types
export interface AddressDto {
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
}

export interface ContractContactDto {
  userId: number;
  name: string;
  email: string | null;
  phone: string | null;
}

export interface PaymentDto {
  paymentId: string;
  paidAt: string | null;
  amount: number;
  paymentMethod: string;
  paymentStatus: string;
  notes: string | null;
}

export interface ContractPageResponse {
  organizationId: number;
  organizationType: string;
  name: string;
  businessRegistrationNumber: string | null;
  representativeName: string | null;
  businessCategory: string | null;
  address: AddressDto | null;
  phoneNumber: string | null;
  email: string | null;
  createdAt: string;
  updatedAt: string;
  contractContact: ContractContactDto | null;
  contractStartDate: string | null;
  contractEndDate: string | null;
  contractStatus: string;
  maxSeats: number;
  usedSeats: number;
  contractAmount: number | null;
  totalPaidAmount: number;
  notes: string | null;
  payments: PaymentDto[];
}

export interface UpdateOrganizationInfoRequest {
  name?: string;
  businessRegistrationNumber?: string;
  representativeName?: string;
  businessCategory?: string;
  address?: AddressDto;
  phoneNumber?: string;
  email?: string;
}

export interface UpdateContractContactRequest {
  userId: number;
}

export const contractApi = {
  getContractPage: () =>
    apiClient.get<ApiResponse<ContractPageResponse>>("/b2b/admin/contract"),

  updateOrganizationInfo: (data: UpdateOrganizationInfoRequest) =>
    apiClient.put<ApiResponse<ContractPageResponse>>("/b2b/admin/contract/info", data),

  updateContractContact: (data: UpdateContractContactRequest) =>
    apiClient.put<ApiResponse<ContractPageResponse>>("/b2b/admin/contract/contact", data),
};
